import { render, staticRenderFns } from "./AgencyMenu.vue?vue&type=template&id=8b495186&"
import script from "./AgencyMenu.vue?vue&type=script&lang=js&"
export * from "./AgencyMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports